import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { useWizard } from 'react-use-wizard/dist/index';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  title: {
    paddingTop: '20px'
  }
}));

export default function DefaultHeader ({ config }) {
  const { t } = useTranslation();
  const { activeStep } = useWizard();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant='h4' align='center' >{t(config.title)}</Typography>
      </div>
      <Stepper activeStep={activeStep}>
        {config.steps.map((step) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={step.key} {...stepProps}>
              <StepLabel {...labelProps} alternativeLabel>{t(step.label)}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}

DefaultHeader.propTypes = {
  config: PropTypes.array.isRequired
};
